const MIN_FONT_SIZE = 150; // Set the minimum font size here
const MAX_FONT_SIZE = 250; // Set the maximum font size here

export const resizeFont = () => {
  const overlays = document.querySelectorAll('.fpo-overlay');

  overlays.forEach((overlay) => {
    const message = overlay.querySelector('.fpo-message') as HTMLElement;
    if (message) {
      const overlayHeight = overlay.clientHeight; // Get the parent's height
      const fontSize = Math.min(
        Math.max(overlayHeight * 0.1, MIN_FONT_SIZE),
        MAX_FONT_SIZE
      ); // Adjust font size
      message.style.fontSize = `${fontSize}px`;
    }
  });
};
